import { render, staticRenderFns } from "./kwai.vue?vue&type=template&id=f66860d6&scoped=true"
import script from "./kwai.vue?vue&type=script&lang=js"
export * from "./kwai.vue?vue&type=script&lang=js"
import style0 from "./kwai.vue?vue&type=style&index=0&id=f66860d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66860d6",
  null
  
)

export default component.exports